// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    LoadProductIfNeeded,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";

export const XngPopulateProperties: typeof LoadProductIfNeeded = props => {
    (props.parameter as any).additionalExpands = ["properties"];
};

/**
 * XNG-Changes: https://xngage.atlassian.net/browse/WEST-1062
 * Issue:
 *  PDP | White Page Until Realtime Pricing & Inventory APIs Load
 * Description:
 *  The PDP shows a white screen until the Pricing and Inventory APIs complete.
 *  Ideally we shouldn’t block the page from loading if it is just pricing that hasn’t loaded yet.
 *  It does not appear to be tied to the “Include Real Time Inventory and Pricing on SEO Product Pages” setting being on or off.
 *
 * Solution:
 *  The Opti doesn't verify the productSettings.inventoryIncludedWithPricing setting when handling a non-WebCrawler request.
 *  To bypass waiting for unnecessary checks, we automatically set pricingLoaded and inventoryLoaded to true for non-WebCrawler requests.
 */
export const XngSkipLoadingForNonWebCrawler: typeof LoadRealTimePrices = props => {
    if (!getIsWebCrawler() && getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        props.pricingLoaded = true;
        props.inventoryLoaded = true;
    }
};

addToChainBefore(chain, LoadProductIfNeeded, XngPopulateProperties);
addToChainBefore(chain, LoadRealTimePrices, XngSkipLoadingForNonWebCrawler);
